import Quill from 'quill';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const StaticContent = () => {

    const editorRef = useRef(null);
    const quillInstance = useRef(null);

    useEffect(() => {
        if (!editorRef.current || quillInstance.current) return;

        quillInstance.current = new Quill(editorRef.current, {
            theme: "snow",
            placeholder: "Write here..."
        });
    }, []);

    const editorTermsRef = useRef(null);
    const quillInstanceTerms = useRef(null);

    useEffect(() => {
        if (!editorTermsRef.current || quillInstanceTerms.current) return;

        quillInstanceTerms.current = new Quill(editorTermsRef.current, {
            theme: "snow",
            placeholder: "Write here..."
        });
    }, []);

    const editorCancelRef = useRef(null);
    const quillInstanceCancel = useRef(null);

    useEffect(() => {
        if (!editorCancelRef.current || quillInstanceCancel.current) return;

        quillInstanceCancel.current = new Quill(editorCancelRef.current, {
            theme: "snow",
            placeholder: "Write here..."
        });
    }, []);

    const editorRefundRef = useRef(null);
    const quillInstanceRefund = useRef(null);

    useEffect(() => {
        if (!editorRefundRef.current || quillInstanceRefund.current) return;

        quillInstanceRefund.current = new Quill(editorRefundRef.current, {
            theme: "snow",
            placeholder: "Write here..."
        });
    }, []);

    const editorAgreementRef = useRef(null);
    const quillInstanceAgreement = useRef(null);

    useEffect(() => {
        if (!editorAgreementRef.current || quillInstanceAgreement.current) return;

        quillInstanceAgreement.current = new Quill(editorAgreementRef.current, {
            theme: "snow",
            placeholder: "Write here..."
        });
    }, []);


    const [homeText, setHomeText] = useState("Every Ride Gives Back");
    const [editHome, setEditHome] = useState(false);

    const [impacts, setImpacts] = useState([
        { text: "Each booking support digital learning", editing: false },
        { text: "Every ride fund meals for 50 families", editing: false },
        { text: "Your 1% helped 3,000 trees", editing: false }
    ]);

    const [singleFields, setSingleFields] = useState({
        allPages: { value: "Together we’ve donated $200 this month.", edit: false },
        checkout: { value: "This trip contributed $200 to community causes", edit: false },
        booking: { value: "Thanks Terri, your trip just helped power community change.", edit: false }
    });

    const toggleImpactEdit = (index) => {
        setImpacts(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, editing: !item.editing } : item
            )
        );
    };

    const updateImpactText = (index, value) => {
        setImpacts(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, text: value } : item
            )
        );
    };

    const deleteImpact = (index) => {
        setImpacts(prev => prev.filter((_, i) => i !== index));
    };

    const addImpact = () => {
        setImpacts(prev => [...prev, { text: "", editing: true }]);
    };

    const toggleSingleEdit = (key) => {
        setSingleFields(prev => ({
            ...prev,
            [key]: { ...prev[key], edit: !prev[key].edit }
        }));
    };

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Static Content</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Static Content</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="ms-auto" />
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            <ul className="nav nav-tabs nav-primary" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#app_tab" role="tab">
                                        <div className="d-flex align-items-center">
                                            <div className="tab-icon font-20"><i className="bx bx-file me-1" /></div>
                                            <div className="tab-title">Terms & Conditions</div>
                                        </div>
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a className="nav-link" data-bs-toggle="tab" href="#terms_tab" role="tab">
                                        <div className="d-flex align-items-center">
                                            <div className="tab-icon font-20"><i className="bx bx-mobile me-1" /></div>
                                            <div className="tab-title">Privacy Policy</div>
                                        </div>
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a className="nav-link" data-bs-toggle="tab" href="#cancel_tab" role="tab">
                                        <div className="d-flex align-items-center">
                                            <div className="tab-icon font-20"><i className="bx bx-file me-1" /></div>
                                            <div className="tab-title">About Us</div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content py-3">
                                <div className="tab-pane fade show active" id="app_tab" role="tabpanel">
                                    <div ref={editorRef} style={{ height: 300 }} />
                                    <div className="editor_btns mt-3 d-flex justify-content-between gap-2">
                                        <button type='button' className="btn btn-decline">Cancel</button>
                                        <button type='button' className="btn btn-approve">Save</button>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="terms_tab" role="tabpanel">
                                    <div ref={editorTermsRef} style={{ height: 300 }} />
                                    <div className="editor_btns mt-3 d-flex justify-content-between gap-2">
                                        <button className="btn btn-decline">Cancel</button>
                                        <button className="btn btn-approve">Save</button>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="cancel_tab" role="tabpanel">
                                    <div ref={editorCancelRef} style={{ height: 300 }} />
                                    <div className="editor_btns mt-3 d-flex justify-content-between gap-2">
                                        <button className="btn btn-decline">Cancel</button>
                                        <button className="btn btn-approve">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default StaticContent